import { useQuery } from '@tanstack/react-query';
import { API } from '~/shared/API/api';
import { useEffect } from 'react';
import { useFreePlacesStore } from '~/shared/store/freeParkingPlaces';

export const useGetParkingSpacesById = (
  id: string | number,
  params?: Record<string, any>
) => {
  const setPlaces = useFreePlacesStore((state) => state.setState);
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ['parking-space', params],
    queryFn: () => API.getParkingSpacesById(id, params),
    retry: 1,
    select: (data) => data.data.payload.items,
  });

  const stages = [...new Set(data?.map((el) => el.level))];

  useEffect(() => {
    if (data) {
      setPlaces(data);
    }
  }, [data]);

  return { stages, data, isLoading, isSuccess };
};
